import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _excluded = ["key", "icon"],
    _excluded2 = ["actions", "logo", "onBack", "onToggleSidebar", "title"];

var _templateObject, _templateObject2, _templateObject3, _ArrowLeftOutlined, _MenuOutlined;

import React from 'react';
import { PageHeader as AntPageHeader } from 'antd';
import { MenuOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import { identity } from 'lodash-es';
import styled from 'styled-components';
import Button from './Button';
import Space from './Space';
var HEADER_HEIGHT = '4rem';
var PageHeader = styled(AntPageHeader)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  &.ant-page-header {\n    position: fixed;\n    z-index: 999;\n    top: 0;\n    left: 0;\n    height: ", ";\n    padding: 1.143rem;\n    border-bottom: 1px solid ", ";\n    width: 100%;\n    background-color: ", ";\n\n    .ant-page-header-heading {\n      height: 100%;\n      align-content: center;\n\n      .ant-page-header-heading-left {\n        margin: 0;\n      }\n\n      .ant-page-header-heading-extra {\n        position: absolute;\n        top: 50%;\n        right: 1.143rem;\n        transform: translateY(-50%);\n        margin: 0;\n      }\n    }\n\n    ", "\n  }\n"])), HEADER_HEIGHT, function (props) {
  return props.theme.colors.grey || '#dfe4e8';
}, function (props) {
  return props.theme.colors.white || '#ffffff';
}, function (props) {
  return props.hasLogo && "\n      .ant-page-header-heading-left {\n        flex-grow: 1;\n\n        .ant-page-header-back {\n          margin-right: 0;\n        }\n\n        .ant-page-header-heading-title {\n          display: flex;\n          justify-content: center;\n          align-items: center;\n          width: 100%;\n          height: 100%;\n        }\n      }\n    ";
});
var Logo = styled.img(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  max-height: ", ";\n"])), HEADER_HEIGHT);
/**
 * Button for actions on the right side of the header
 * Extending @kargotech/tms-ui/components/Button component
 *
 * Usage:
 * <PageHeaderMobile.IconButton
 *  icon={<PlusOutlined />}
 *  onClick={...}
 * />
 */

var IconButton = styled(Button)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  width: 1.714rem;\n  height: 1.714rem;\n  font-size: 1.143rem;\n  line-height: 1.143rem;\n"])));
IconButton.defaultProps = {
  type: 'text'
};

var RightMenu = function RightMenu(_ref) {
  var _ref$actions = _ref.actions,
      actions = _ref$actions === void 0 ? [] : _ref$actions;
  return /*#__PURE__*/React.createElement(Space, {
    size: 8
  }, actions.map(function (_ref2) {
    var key = _ref2.key,
        icon = _ref2.icon,
        iconProps = _objectWithoutProperties(_ref2, _excluded);

    return /*#__PURE__*/React.createElement(IconButton, _extends({
      key: key,
      icon: icon
    }, iconProps));
  }));
};
/**
 * Header for mobile page
 *
 * @param {Array} actions actions to display on the right side of the header
 * @param {String} logo logo source
 * @param {Function} onBack callback when back button is clicked
 * @param {Function} onToggleSidebar callback when sidebar menu is clicked
 * @param {String} title title to display
 * Other props will be directly passed into antd PageHeader component
 *
 * @returns {ReactNode}
 */


var PageHeaderMobile = function PageHeaderMobile(_ref3) {
  var _ref3$actions = _ref3.actions,
      actions = _ref3$actions === void 0 ? [] : _ref3$actions,
      _ref3$logo = _ref3.logo,
      logo = _ref3$logo === void 0 ? null : _ref3$logo,
      _ref3$onBack = _ref3.onBack,
      onBack = _ref3$onBack === void 0 ? identity : _ref3$onBack,
      _ref3$onToggleSidebar = _ref3.onToggleSidebar,
      onToggleSidebar = _ref3$onToggleSidebar === void 0 ? identity : _ref3$onToggleSidebar,
      _ref3$title = _ref3.title,
      title = _ref3$title === void 0 ? null : _ref3$title,
      pageHeaderProps = _objectWithoutProperties(_ref3, _excluded2);

  var backIcon = title ? _ArrowLeftOutlined || (_ArrowLeftOutlined = /*#__PURE__*/React.createElement(ArrowLeftOutlined, null)) : _MenuOutlined || (_MenuOutlined = /*#__PURE__*/React.createElement(MenuOutlined, null));
  var handleBack = title ? onBack : onToggleSidebar;
  var logoImage = typeof logo === 'string' && /*#__PURE__*/React.createElement(Logo, {
    alt: "logo",
    src: logo
  });
  var customLogo = logo && typeof logo !== 'string' && /*#__PURE__*/React.createElement(React.Fragment, null, logo);
  var extra = Boolean(!title && (actions === null || actions === void 0 ? void 0 : actions.length)) && /*#__PURE__*/React.createElement(RightMenu, {
    actions: actions
  });
  return /*#__PURE__*/React.createElement(PageHeader, _extends({
    backIcon: backIcon,
    extra: extra,
    hasLogo: !title && Boolean(logoImage || customLogo),
    onBack: handleBack,
    title: title || logoImage || customLogo
  }, pageHeaderProps));
};

PageHeaderMobile.IconButton = IconButton;
export default PageHeaderMobile;